export const resetValue = (keys, onSetFieldValue) => {
  return keys.forEach((key) => onSetFieldValue(key, ''));
};
